module.exports = __webpack_public_path__ + "img/app_icon.57284368.svg";